import React, { useContext, useState } from 'react'
import Card from '../component/component/Tour/Card'
import { StarterContext } from '../store/Starter'

function Tour({ classes, title }) {
    const { tourPlan } = useContext(StarterContext)
    const [tour, settour] = useState(tourPlan)
    const tourDelete = (e) => {
        settour(tour.filter((tourItem,i) => {
            return i !== e;
        }))
    }
    return (
        <>
            <h1 className={classes}>{title}</h1>
            <div className="container">
                <div className="row">
                    {
                        tour.map((tourP, i) => {
                            return <Card key={i} data={{...tourP,tourDelete,i}} />
                        })
                    }
                </div>
            </div>
        </>
    )
}

export default Tour
